const doc = [({"da":({"js":({"admin":({"photo_qualities":({"select":({"choose_photo_quality":"Vælg fotokvalitet"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;